// The react-grid-layout geometry for every home page layout type. This object is the
// source of truth: a saved layout stores only its type (gridLayout.layoutType) and which
// widget goes in each card (gridLayout.layoutContent), and GridLayoutComponent looks the
// geometry up here by type. The settings picker (HomePageLayout) lists its keys, and its
// card dropdowns are built from the selected entry.
//
// ADDING A LAYOUT TYPE
//
// 1. Add an entry here. The key is both the label in the picker and the string
//    persisted as gridLayout.layoutType. Never rename or remove an existing key —
//    saved layouts are matched back to it, and one with no entry renders empty.
// 2. Name the items 'card1' ... 'cardN' in array order. The widget dropdowns in
//    HomePageLayout key their selection by array index (`card${index + 1}`), not by
//    `i`, so a gap or a reordering assigns widgets to the wrong cards.
// 3. `w` spans the 12 columns. `h` is a row weight, not pixels: GridLayoutComponent
//    divides the viewport by the layout's total row count, so '3 X (1, 2, 3)' below
//    (h of 1, 4 and 3 = 8 rows) gives its three bands 1/8, 4/8 and 3/8 of the screen.
//    Keep the total modest — every row is a share of one screen, never a scroll.
// 4. Give `y` its true post-compaction value (0, 1, 2 ...). RGL compacts vertically,
//    so the stale gaps in the older entries below (y: 6 on a two row layout) still
//    render correctly, but GridLayoutComponent sizes its first frame from the raw
//    `y` and only corrects once RGL reports the compacted layout back.
//    Contiguous values avoid that flash.
// 5. Add a matching LAYOUT_PREVIEWS entry in HomePageLayout, or the settings
//    preview silently renders blank.
//
// Nothing needs to change in GridLayoutComponent — it derives its row count from
// the layout data, so a new type fits the screen without a code change there.
const LAYOUT_CONFIGURATIONS = {
    '1 X 1': [
        { i: 'card1', x: 0, y: 0, w: 12, h: 1 }
    ],
    '1 X 2': [
        { i: 'card1', x: 0, y: 0, w: 6, h: 1 },
        { i: 'card2', x: 6, y: 0, w: 6, h: 1 }
    ],
    '2 X 1': [
        { i: 'card1', x: 0, y: 0, w: 12, h: 1 },
        { i: 'card2', x: 0, y: 6, w: 12, h: 1 }
    ],
    '2 X 2': [
        { i: 'card1', x: 0, y: 0, w: 6, h: 1 },
        { i: 'card2', x: 6, y: 0, w: 6, h: 1 },
        { i: 'card3', x: 0, y: 6, w: 6, h: 1 },
        { i: 'card4', x: 6, y: 6, w: 6, h: 1 }
    ],
    '2 X (1, 2)': [
        { i: 'card1', x: 0, y: 0, w: 12, h: 1 },
        { i: 'card2', x: 0, y: 3, w: 6, h: 1 },
        { i: 'card3', x: 6, y: 3, w: 6, h: 1 }
    ],
    '(1, 2) X 2': [
        { i: 'card1', x: 0, y: 0, w: 6, h: 2 },
        { i: 'card2', x: 6, y: 0, w: 6, h: 1 },
        { i: 'card3', x: 6, y: 3, w: 6, h: 1 }
    ],
    '3 X (1, 2, 3)': [
        { i: 'card1', x: 0, y: 0, w: 12, h: 1 },
        { i: 'card2', x: 0, y: 1, w: 6, h: 4 },
        { i: 'card3', x: 6, y: 1, w: 6, h: 4 },
        { i: 'card4', x: 0, y: 5, w: 4, h: 3 },
        { i: 'card5', x: 4, y: 5, w: 4, h: 3 },
        { i: 'card6', x: 8, y: 5, w: 4, h: 3 }
    ],
};

export default LAYOUT_CONFIGURATIONS;
